import { PerformanceMetrics } from '../types';

/**
 * 数据上报器
 */
export class PerformanceReporter {
  private reportUrl?: string;
  private reportInterval: number;
  private intervalId: number | null = null;
  private dataQueue: PerformanceMetrics[] = [];

  constructor(reportUrl?: string, reportInterval: number = 30000) {
    this.reportUrl = reportUrl;
    this.reportInterval = reportInterval;
  }

  /**
   * 开始定期上报
   */
  start(): void {
    if (this.intervalId) {
      this.stop();
    }

    this.intervalId = window.setInterval(() => {
      this.report();
    }, this.reportInterval);
  }

  /**
   * 停止定期上报
   */
  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  /**
   * 添加数据到队列
   */
  addData(data: PerformanceMetrics): void {
    this.dataQueue.push({
      ...data,
      timestamp: Date.now(),
      url: window.location.href,
      userAgent: navigator.userAgent
    });
  }

  /**
   * 立即上报数据
   */
  async report(): Promise<void> {
    if (this.dataQueue.length === 0) return;

    const dataToReport = [...this.dataQueue];
    this.dataQueue = [];

    if (this.reportUrl) {
      try {
        await this.sendData(dataToReport);
      } catch (error) {
        console.warn('Performance data report failed:', error);
        // 失败时重新加入队列
        this.dataQueue.unshift(...dataToReport);
      }
    } else {
      // 如果没有配置上报URL，则输出到控制台
      console.log('Performance Metrics:', dataToReport);
    }
  }

  /**
   * 发送数据到服务器
   */
  private async sendData(data: PerformanceMetrics[]): Promise<void> {
    if (!this.reportUrl) return;

    const response = await fetch(this.reportUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        timestamp: Date.now(),
        data: data,
        sessionId: this.getSessionId()
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  }

  /**
   * 获取会话ID
   */
  private getSessionId(): string {
    let sessionId = sessionStorage.getItem('performance_sdk_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('performance_sdk_session_id', sessionId);
    }
    return sessionId;
  }

  /**
   * 获取队列中的数据数量
   */
  getQueueSize(): number {
    return this.dataQueue.length;
  }

  /**
   * 清空数据队列
   */
  clearQueue(): void {
    this.dataQueue = [];
  }
} 